import { transport } from 'config/transport';

export function callApiGetListOfClasses(gradeId) {
    return transport.get(`/mamnon/grades/${gradeId}/classes`);
}
